'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var ClientData = (0, _immutable.Record)({
  isAdmin: true,
  isPubNubClientConnected: false,
  forceClientOffline: false,
  chatConfig: null,
  uuid: null,
  isInForeground: true,
  serverTimeOffsetInMs: 0,
  sessionStartedAt: null,
  timestamps: (0, _immutable.OrderedMap)()
}, 'ClientData');

exports.default = ClientData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/ClientData.js
// module id = 195
// module chunks = 0 1